import { render, staticRenderFns } from "./CommissionDistributionRuleRangeManage.vue?vue&type=template&id=cded0e84&scoped=true"
import script from "./CommissionDistributionRuleRangeManage.vue?vue&type=script&lang=js"
export * from "./CommissionDistributionRuleRangeManage.vue?vue&type=script&lang=js"
import style0 from "./CommissionDistributionRuleRangeManage.vue?vue&type=style&index=0&id=cded0e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cded0e84",
  null
  
)

export default component.exports